import * as actionTypes from "./../../actionTypes";
import AuthService from "./../../services/authService";
import { firebaseDatabase } from "./../../services/firebaseService";
import {
    apiAdminUrl,
    apiBaseUrl,
    apiMediaUrl,
    WebDomain,
} from "./../../common";
import swal from "sweetalert";

const handleResponse = (response) => {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401 || response.status === 400) {
                swal({
                    title: "Expired!",
                    text: "Your session is expired!",
                    icon: "error",
                });
                localStorage.removeItem("token");
                window.location.href = `https://${WebDomain}`;
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
};

export const InviteForMeet = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.INVITE_FOR_MEET, payload: data });
    };
};

export const InviteForLobby = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.INVITE_FOR_LOBBY, payload: data });
    };
};

export const MeetingsList = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}userPanel/meeting-listing`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.MEETINGS_LIST,
                        payload: data.data,
                    });
                    dispatch({
                        type: actionTypes.MEETINGS_COUNT,
                        payload: data.count,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const RecordingList = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/call-recording-list`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.RECORDING_LIST,
                        payload: data.data,
                    });
                    dispatch({
                        type: actionTypes.RECORDING_COUNT,
                        payload: data.count,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};
export const InstantMeeting = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}/instant-meeting`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                if (data.ResponseCode === "1") {
                    return data;
                }
            });
    };
};

export const ScheduleMeeting = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}userPanel/create-meeting`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const getMediaDownloadUrl = (filename) => {
    const token = AuthService.getUserAccessToken();
    const request = new Request(
        `${apiMediaUrl}userPanel/image_signed_url?objectName=${filename}`,
        {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        }
    );
    return fetch(request)
        .then(handleResponse)
        .then((data) => {
            if (data.ResponseCode === "1") {
                return data?.url;
            } else {
                return "";
            }
        })
        .catch((error) => {
            return "";
        });
};

export const ExtensionList = (id = 0, loader = true, path = null) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: loader });
        const request = new Request(
            `${path ? apiAdminUrl : apiBaseUrl}/userPanel/${
                path ?? `extension/${id}`
            }`,
            {
                method: path ? "POST" : "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    // dispatch({
                    //     type: actionTypes.FETCH_EXTENSION_LISTING,
                    //     payload: data.data,
                    // });
                    const { data: extensionList } = data;
                    extensionList.forEach(async (element, index) => {
                        const { app_picture } = element;
                        if (app_picture) {
                            const url = await getMediaDownloadUrl(app_picture);
                            element.profile_picture = url;
                            extensionList[index] = element;
                        } else {
                            element.profile_picture = "";
                            extensionList[index] = element;
                        }
                        dispatch({
                            type: actionTypes.FETCH_EXTENSION_LISTING,
                            payload: [...extensionList],
                        });
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const validateMeeting = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}detect-auth-params`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    const {
                        is_owner,
                        created_by_name: host_name,
                        meet_type,
                        room_name,
                        topic,
                        timestamp,
                        locked,
                        created_by_phone: phone,
                        meeting_time,
                        authSharing: auth_share,
                        authorised: join_authorized,
                        enableLobby,
                        joinAfterHost: join_after_host,
                        uniquekey,
                        media,
                    } = data;
                    let payload = {
                        is_owner,
                        host_name,
                        meet_type,
                        room_name,
                        topic,
                        timestamp,
                        locked,
                        phone,
                        meeting_time,
                        uniquekey,
                        media,
                    };
                    // IF MEETING IS SCHEDULED
                    if (meet_type === "scheduled") {
                        payload = {
                            ...payload,
                            auth_share,
                            join_authorized,
                            enableLobby,
                            join_after_host,
                        };
                    }
                    dispatch({ type: actionTypes.MEETING_DETAILS, payload });
                    return {
                        code: 1,
                        password_protected: data.ResponseText,
                        ...payload,
                    };
                } else {
                    return { code: 0, response: data.ResponseText };
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                return { code: 0, response: error };
            });
    };
};

export const AuthorizeMeeting = (params, toast = false) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}authorize-meeting`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    return { code: 1 };
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return { code: 0, response: data.ResponseText };
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                return { code: 0, response: error };
            });
    };
};

export const TimezoneList = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/timezone_listing`, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                dispatch({
                    type: actionTypes.TIMEZONE_LIST,
                    payload: data.data,
                });
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const UpdateMeeting = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/update-meeting`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                if (data.ResponseCode === "1") {
                    return data;
                }
            });
    };
};

export const DeleteMeeting = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiBaseUrl}/userPanel/delete-meeting`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.TOASTR,
                        payload: {
                            duration: 1500,
                            message: data.ResponseText,
                            type: "success",
                        },
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            });
    };
};

export const EditMeet = (data) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.EDIT_MEET_DATA, payload: data });
    };
};

export const VideoRecordingList = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}/userPanel/recording-url-listing`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.VIDEO_RECORDING_LIST,
                        payload: data.data,
                    });
                    dispatch({
                        type: actionTypes.RECORDING_COUNT,
                        payload: data.count,
                    });
                }
                return 1;
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const PushNotifications = (data) => {
    return (dispatch) => {
        const request = new Request(
            `${apiBaseUrl}Nxatel/push.php?service=apns&tonumber=${data.toNumber}&type=video&number=${data.fromNumber}&message=${data.roomID}&domain=${data.domain}&NotificationType=JitsiCall`,
            {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                    Accept: "application/json",
                }),
            }
        );
        fetch(request);
    };
};

export const StartMeet = async (toNumber) => {
    let { phone, domain } = AuthService.getUserDetail();
    toNumber = toNumber.toString().replace("+", "");
    phone = phone.toString().replace("+", "");
    let roomID =
        toNumber > phone ? `${toNumber}_${phone}` : `${phone}_${toNumber}`;
    // window.location.href = `/${roomID}`
    makeCall(toNumber, phone, roomID, domain);
};

export const makeCall = (toNumber, phone, roomID, domain) => {
    APP.store.dispatch(
        PushNotifications({ roomID, toNumber, fromNumber: phone, domain })
    );
    firebaseDatabase.ref("Call").child(roomID).set({
        from: phone,
        to: toNumber,
        status: "ringing",
    });
};

export const DocumentsList = () => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiBaseUrl}userPanel/user-files-listing`,
            {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    dispatch({
                        type: actionTypes.DOCUMENTS_LIST,
                        payload: data.data,
                    });
                    return 1;
                } else {
                    return 0;
                }
            })
            .catch((error) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
            });
    };
};

export const LockMeeting = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}userPanel/lock-meeting`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({
                "Content-Type": "application/json",
                "X-Auth-Token": token,
            }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((data) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (data.ResponseCode === "1") {
                    swal({
                        title: "Success!",
                        text: data.ResponseText,
                        icon: "success",
                    });
                    return 1;
                } else {
                    swal({
                        title: "Error!",
                        text: data.ResponseText,
                        icon: "error",
                    });
                    return 0;
                }
            })
            .catch(() => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                swal({
                    title: "Error!",
                    text: "Error Occured",
                    icon: "error",
                });
                return 0;
            });
    };
};

export const FetchRunningMeet = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(`${apiAdminUrl}fetch-running-meet`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: new Headers({ "Content-Type": "application/json" }),
        });
        return fetch(request)
            .then(handleResponse)
            .then((response) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (response.ResponseCode === "1") {
                    return { code: 1, response: response.data };
                }
                return { code: 0 };
            });
    };
};

export const ActivateMeet = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiAdminUrl}/userPanel/activate-meeting`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((response) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (response.ResponseCode === "1") {
                    return 1;
                } else {
                    return 0;
                }
            });
    };
};

export const DefaultLobby = (payload) => {
    APP.store.dispatch({ type: actionTypes.DEFAULT_LOBBY_IS_ON, payload });
};

export const UpdateMeetingStatus = (params) => {
    const token = AuthService.getUserAccessToken();
    return (dispatch) => {
        dispatch({ type: actionTypes.SHOW_LOADER, payload: true });
        const request = new Request(
            `${apiAdminUrl}/userPanel/update-meeting-status`,
            {
                method: "POST",
                body: JSON.stringify(params),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-Auth-Token": token,
                }),
            }
        );
        return fetch(request)
            .then(handleResponse)
            .then((response) => {
                dispatch({ type: actionTypes.SHOW_LOADER, payload: false });
                if (response.ResponseCode === "1") {
                    return 1;
                } else {
                    return 0;
                }
            });
    };
};
